module.exports = __webpack_public_path__ + "media/ring-call.9c9433e8.mp3";